import { createFileRoute } from "@tanstack/react-router";
import { TeachersPage } from "@/projects/admin/pages/TeachersPage";

export const Route = createFileRoute("/admin/teachers")({
  head: () => ({ meta: [{ title: "Teacher Management — Admin" }] }),
  component: TeachersPage,
});
